import { AppAlert, AppLoadingSpinner } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { CommentInput } from './components/CommentInput'
import { CommentItem } from './components/CommentItem'
import { useCommentsSection } from './hooks/useCommentsSection'
import type { CommentsSectionProps } from './types'

/**
 * コメントセクションコンポーネント
 *
 * コメントの一覧表示・作成・編集・削除を提供する共通コンポーネント
 */
export function CommentsSection({ opportunityId, editable, onCommentsLoaded }: CommentsSectionProps) {
  const {
    comments,
    isLoading,
    isRefetching,
    error,
    currentMemberId,
    isAdministrator,
    scrollContainerRef,
    isCreating,
    isUpdating,
    handleReload,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useCommentsSection({ opportunityId, onCommentsLoaded })

  if (isLoading) {
    return (
      <div className='flex h-full items-center justify-center p-8'>
        <AppLoadingSpinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className='p-4'>
        <AppAlert type='error'>コメントの取得に失敗しました: {error.message}</AppAlert>
      </div>
    )
  }

  return (
    <div className='h-full flex flex-col overflow-hidden'>
      {comments.length === 0 && !isRefetching && (
        <div className='p-4'>
          <AppAlert type='info'>コメントはありません</AppAlert>
        </div>
      )}

      <div className='flex-1 overflow-y-auto overflow-x-hidden px-4 relative' ref={scrollContainerRef}>
        {isRefetching && (
          <div className='absolute inset-0 bg-background/50 flex items-center justify-center z-10'>
            <AppLoadingSpinner />
          </div>
        )}
        {comments.length > 0 && (
          <div className='py-2'>
            {comments.map((comment) => (
              <CommentItem
                key={comment.id}
                comment={comment}
                editable={editable}
                currentMemberId={currentMemberId}
                isAdministrator={isAdministrator}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
                isUpdating={isUpdating}
              />
            ))}
          </div>
        )}
      </div>

      {editable && (
        <CommentInput
          onCreate={handleCreate}
          onReload={handleReload}
          isRefetching={isRefetching}
          isCreating={isCreating}
        />
      )}
    </div>
  )
}
